import React from 'react';

export function PromotionalVideo({ video }) {
  return (
    <section className="flex-1">
      <div className="flex items-center justify-center">
        <video
          className="rounded-[41px] w-[69.562rem] h-auto  "
          width="100%"
          height="100%"
          src={video.url}
          title="Vídeo de apresentação"
          controls
        />
      </div>
    </section>
  );
}
